import { DashboardFilterInstance, FiltersRegistry } from "../../types";
import { DashboardFilterResolved } from "../dashboardSelectors";

export const getRootCauseDashboardFilters = (
	registry: FiltersRegistry | null,
	dashboardFilters: DashboardFilterInstance[]
): DashboardFilterResolved[] => {
	if (!registry) return [];

	return dashboardFilters
		.map((instance) => {
			const filter = registry.byId[instance.filterId];

			if (!filter) return null;

			return {
				instance,
				filter,
				isAvailable: true,
			};
		})
		.filter(Boolean) as DashboardFilterResolved[];
};
